import { useLocation } from "react-router-dom";

export const useQueryParam = (param: string) => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    return queryParams.get(param);
};
